module.exports = __webpack_public_path__ + "images/b7719a7813d2f19db584074ae810c7c2-illu_dir_sign3.png";